import { render, staticRenderFns } from "./help-exclamation.vue?vue&type=template&id=16082ed6&"
import script from "./help-exclamation.vue?vue&type=script&lang=js&"
export * from "./help-exclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports